import type { SmartApplyPartner } from '@percent/cause-dashboard/constants/smartApplyPartnerConfig'
import { SmartApplyVariantA } from './smartApplyVariantA/SmartApplyVariantA'

type SmartApplyVariantRouterProps = {
  hasCanvaApplication: boolean
  setSelectedPartner?: (partner: SmartApplyPartner) => void
  appliedPartners?: Set<SmartApplyPartner>
  page?: number | null
  pagesCount?: number
  secondaryAction?: () => void
  onClose: () => void
  registerDismissCallback?: (callback: (() => void) | null) => void
}

export function SmartApplyVariantRouter(props: Readonly<SmartApplyVariantRouterProps>) {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noop = () => {}
  const setSelectedPartner = props.setSelectedPartner || noop

  return <SmartApplyVariantA {...props} setSelectedPartner={setSelectedPartner} />
}
